export const legalDocuments = {
  gdpr: 'https://drive.google.com/file/d/1JtNS2x7WN9LM7HKVgZKdZNXKL39HCGLY/view',
  aszf: 'https://drive.google.com/file/d/12qHpblnCUgDuvVQS0Uqo2y6m5Bq7zhnh/view',
};
